<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">

      <b-row>
        <b-col md="6" sm="12" class="mt-2 pb-4">
          <p class="reg-heading-tab">Personal Details</p>
          <p></p>
          <div
            class="reg-tab-container"
          >
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Full Name*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="First Name"
                    style="width:130px"
                    v-model="form.FirstName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-prepend>

                <b-form-input
                  type="text"
                  placeholder="Middle Name"
                  size="sm"
                  required
                  v-model="form.MiddleName"
                  :formatter="format"
                  lazy-formatter
                  style="width:75px"
                ></b-form-input>

                <b-input-group-append>
                  <b-form-input
                    type="text"
                    required
                    placeholder="Last Name"
                    size="sm"
                    style="width:130px"
                    v-model="form.LastName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Gender*"
              label-size="sm"
              label-for="radiosg"
            >
              <b-form-radio-group id="radiosg" v-model="form.Gender">
                <b-form-radio value="true">Male</b-form-radio>
                <b-form-radio value="false">Female</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Birth Date*"
              label-size="sm"
              label-for="exampleInput3"
            >
              <date-picker
                v-model="DOB"
                :state="validateAge"
                :min="minAge"
                :max="maxAge"
                format="DD-MM-YYYY"
                lang="en"
                required
                size="small"
              ></date-picker>
              <label class="ml-2">Age: {{form.Age}}</label>
            </b-form-group>

            <!-- <b-form-group id="grpAddress" horizontal label-size="sm" label="Place of Birth">
              <b-form-input
                id="exampleInput2"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.PlaceOfBirth"
                required
                size="sm"
                placeholder="Place of Birth"
              ></b-form-input>
            </b-form-group>-->
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Email ID"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="email"
                v-model="form.EmailID"
                size="sm"
                placeholder="Valid Email ID"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Mobile*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="number"
                :state="mobileNumber"
                v-model="form.MobileNo"
                required
                size="sm"
                min="1000000000"
                max="9999999999"
                placeholder="10 digit Mobile Number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Landline Number"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="text"
                v-model="form.LandlineNo"
                size="sm"
                :formatter="format"
                lazy-formatter
                placeholder="Landline Number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Mother's Name"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.MotherName"
                size="sm"
                placeholder="Mother's Name"
              ></b-form-input>
            </b-form-group>
            <b-form-group
          id="exampleInputGroup4"
          horizontal
          label="Are you Handicap"
          label-size="sm"
          label-for="radiosg"
        >
          <b-form-radio-group id="radiosh" v-model="form.ExServiceMan">
            <b-form-radio value="true">Yes</b-form-radio>
            <b-form-radio value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="mt-2">
          <p>
            <span class="reg-heading-tab">Other Details</span>
          </p>

          <div
            class="reg-tab-container"
          >
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Adhar Card No.*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                :formatter="format"
                lazy-formatter
                size="sm"
                :state="validateAadhar"
                v-model="form.AdharNo"
                placeholder="Aadhar Number 12 digit"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Pancard No.*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.PanCardNo"
                :state="validatePan"
                placeholder="PAN 10 digit"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Married Status"
              label-size="sm"
              label-for="exampleInput2"
              label-cols="4"
            >
              <b-form-radio-group
                id="radiosM"
                v-model="form.MaritalStatus"
                name="radioSubComponentM"
              >
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Indian National"
              label-size="sm"
              label-for="exampleInput3"
              label-cols="4"
            >
              <b-form-radio-group id="radiosN" v-model="form.Nationality" name="radioSubComponentN">
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup4"
              horizontal
              label="Maharashtra Domicile"
              label-size="sm"
              label-for="exampleInput4"
              label-cols="4"
            >
              <b-form-radio-group id="radiosD" v-model="form.Domiciled" name="radioSubComponentD">
                <b-form-radio value="true">Yes</b-form-radio>
                <b-form-radio value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <!-- <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Mother Toungue"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.MotherToung"
                placeholder="Mother Toungue"
              ></b-form-input>
            </b-form-group>-->

            <b-form-group
              id="exampleInputGroup5"
              horizontal
              label-cols="4"
              label="Caste*"
              label-size="sm"
              label-for="exampleInput5"
            >
              <b-form-select
                id="exampleInput5"
                :options="Caste"
                value-field="CasteID"
                text-field="CasteName"
                required
                size="sm"
                v-model="form.CasteID"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup6"
              horizontal
              label-cols="4"
              label="Total Family Income (Rs)*"
              label-size="sm"
              label-for="exampleInput6"
            >
              <b-form-input
                id="exampleInput6"
                type="number"
                v-model="form.FamilyIncome"
                required
                size="sm"
                min="1.0"
                max="800000"
                placeholder="Family Income"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup7"
              horizontal
              label="Ration Card No.*"
              label-size="sm"
              label-for="exampleInput7"
              label-cols="4"
            >
              <b-form-input
                id="exampleInput7"
                type="text"
                v-model="form.RationCardNo"
                required
                size="sm"
                placeholder="Ration Card No."
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2" v-if="!form.LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <br>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
export default {
  name: "PersonalDetails",
  components: { Spinner, DatePicker },
  props:["Loantype"],
  data() {
    return {
      isAdrsSame: false,
      options: [
        { text: "Marathi", value: "Marathi" },
        { text: "Hindi", value: "Hindi" },
        { text: "English", value: "English" },
        { text: "Other", value: "Other" }
      ],
      DOB: null,
      form: {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: null,
        Age: 0,
        PlaceOfBirth: "",
        MobileNo: "",
        EmailID: "",
        LandlineNo: "",
        MotherName: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        ExServiceMan: false,
        Driving: false,
        MotherToung: "Marathi",
        CasteID: "",
        Marathi: true,
        Hindi: false,
        English: false,
        Other: false,
        OtherLanguages: "",
        BoardID: "",
        FamilyIncome: 0.0,
        RationCardNo: "",
        RegistrationType: 0
      },
      Caste: ["OBC", "MATADI"],
      isEmpExchange: false,
      religions: [],
      categories: [],
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      saved: false,
      minAge:18,
      maxAge:50,
      TempLoantype:0,
      options: [
        { value: 0, text: "Resgistration as New Secuirty Guard" },
        { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
        {
          value: 2,
          text:
            "Recommanded by registered Principal Employer for Registration and Allotment"
        },
        { value: 3, text: "Registration on Compassionate Ground" },
        { value: 4, text: "Registration by Court Orders" }
      ],
      relations: [
        "Son",
        "Daughter",
        "Wife",
        "Husband",
        "Brother",
        "Sister",
        "Other"
      ]
    };
  },
  computed: {
    mobileNumber() {
    this.TempLoantype=this.Loantype;
      if (this.form.MobileNo != null) {
        var phoneno = /^\d{10}$/;
        if (this.form.MobileNo.match(phoneno)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAadhar() {
      if (this.form.AdharNo == null) {
        return false;
      }

      if (this.form.AdharNo.length == 0) {
        return false;
      } else if (this.form.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.form.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.form.PanCardNo == null) {
        return false;
      }

      if (this.form.PanCardNo.length == 0) {
        return false;
      } else if (this.form.PanCardNo != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.PanCardNo.match(panformat)) {
          return true;
        } else {
          return false;
        }
        //PAN 5th letter should match Surname's first l
        //Kuldip Removed this condition as Married woman face problem
        // if (
        //   this.form.PanCardNo.match(panformat) &&
        //   this.form.PanCardNo.charAt(4).toLowerCase() ==
        //     this.form.LastName.charAt(0).toLowerCase()
        // ) {
        //   return true;
        // } else {
        //   return false;
        // }
        //return true;
      } else {
        return false;
      }
    },
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);
      let age = this.calculateAge(this.DOB);

      this.form.Age = age;
      if(this.TempLoantype==1 || this.TempLoantype=='1'){
        console.log("indi loan");
      if (age < 18 || age >= 50) {
        return false;
      }
      else {
        return true;
      }
    }
    else if(this.TempLoantype==2 || this.TempLoantype=='2'){
      console.log("Group loan");
      if (age < 18 || age >= 45) {
        return false;
      }
      else {
        return true;
      }
    }
    else if(this.TempLoantype==3 || this.TempLoantype=='3'){
      console.log("Education loan");
      if (age < 17 || age >= 30) {
        return false;
      }
      else {
        return true;
      }
    }

    }
  },
  methods: {
    loadSignupUser(){
      let userinfo= this.$store.getters.loggedUser;
      this.form.FirstName = userinfo.FirstName;
      this.form.MiddleName = userinfo.MiddleInitial;
      this.form.LastName = userinfo.LastName;
      this.form.MobileNo = userinfo.Mobile;
      this.form.EmailID = userinfo.EmailID;
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    format(value, event) {
      if (value != null) {
        return value.trim();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    convertDateFormat(indate) {
      return indate.split("T")[0];
    },
    // Retries a request once on a transient network failure (e.g. dropped
    // connection/timeout) before surfacing an error. Safe here because the
    // save is an upsert keyed by LoginID, so retrying is idempotent.
    withRetry(apiCall) {
      return apiCall().catch(err => {
        if (err && err.status) throw err; // real server error - don't retry
        return new Promise(resolve => setTimeout(resolve, 800)).then(apiCall);
      });
    },
    setRegType() {
      this.$store.dispatch("setRegType", this.form.RegistrationType);
    },
    getCaste() {
      let promiseA = apis.getCaste();

      promiseA
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            this.Caste = response.body;
          } else {
            this.alertText = "Unable to get caste List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = "Unable to get caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n-1;

      // let otherDate = new Date();

      // var years = otherDate.getFullYear() - birthDate.getFullYear();
      // var months = years*12

      // if (
      //   otherDate.getMonth() < birthDate.getMonth() ||
      //   (otherDate.getMonth() == birthDate.getMonth() &&
      //     otherDate.getDate() < birthDate.getDate())
      // ) {
      //   years--;
      // }

      // return years;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      this.saved = false;
      if (!this.form.Domiciled || this.form.Domiciled == "false") {
        this.alertText =
          "Only Maharashtra Domiciled Citizens are allowed in the scheme.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.form.Nationality || this.form.Nationality == "false") {
        this.alertText = "Only Indian Nationals are allowed in the scheme.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validateAadhar) {
        this.alertText = "Please verify the Aadhar number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validatePan) {
        this.alertText = "Please verify the PAN";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validateAge) {
        this.alertText = "Age Criteria not fulfilled";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      if (this.form.DeceasedRelation != "Other") {
        this.form.OtherRelationName = "";
      }
      this.form.DOB = Formatter.convertDateFormatYMD(this.DOB);

      let promise = this.withRetry(() => apis.saveUserRegistration(this.form));
      this.$store.dispatch("setUserData", this.form);
      console.log(this.form);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200 && response.body=="Data Saved Successfully") {
            this.alertText = "Data Saved Successfully";

            this.variant = "success";
            this.showDismissibleAlert = true;
            this.saved = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while saving data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form = {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: null,
        Age: 0,
        PlaceOfBirth: "",
        MobileNo: "",
        EmailID: "",
        LandlineNo: "",
        MotherName: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        ExServiceMan: false,
        Driving: false,
        MotherToung: "Marathi",
        BoardID: "",
        RationCardNo: "",
        UserReligionCaste: {
          ReligionID: "",
          CategoryID: "",
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: "",
          EmploymentRegNo: ""
        },
        RegistrationType: 0,
        DeceasedRelation: "",
        DeceasedRegNum: "",
        DeceasedName: "",
        PetitionNum: "",
        OrderNum: "",
        OrderDate: null,
        PetitionDate: "",
        UnionName: "",
        OtherRelationName: "",
        LockProfile: false
      };
    },
    filterDistricts() {},
    filterTalukas() {}
  },
  mounted() {
    this.getCaste();
    var userinfo = this.$store.getters.loggedUser;
    if (this.$store.getters.isLoggedIn) {
      let promiseU = apis.ReadUserDetail(userinfo.UserId);

      promiseU
        .then(response => {
          if (response.status == 200) {
            //console.log(response.body);
            this.form = response.body;
            //this.form.DOB = this.convertDateFormat(response.body.DOB);
            this.DOB = this.form.DOB;
            this.OrderDate = this.form.OrderDate;
            this.PetitionDate = this.form.PetitionDate;

            this.$store.dispatch("setUserData", this.form);
            this.$store.dispatch("setRegType", this.form.RegistrationType);
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  }
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/PersonalDetails.vue